import { memo, useEffect } from 'react';
import { useUpdateNodeInternals } from '@xyflow/react';
import { clsx } from 'clsx';

import type { ICustomBoardNode } from '../interfaces/ICustomBoardNode';

import styles from '../sass/CustomBoardNode.module.scss';

function CustomBoardNode({ id, data }: ICustomBoardNode) {
  const updateNodeInternals = useUpdateNodeInternals();

  useEffect(() => {
    updateNodeInternals(id);
  }, [
    data.accumulatedMaxBoardHeight,
    data.boardWidth,
    data.isDraftReviewMode,
    data.name,
    id,
    updateNodeInternals,
  ]);

  return (
    <div
      className={clsx(styles.container, {
        [styles.dragTarget]: data.isDragTarget === true,
        [styles.validSectionHighlight]: data.isValidSectionHighlight === true,
        [styles.invalidDropTarget]: data.isInvalidDropTarget === true,
        [styles.scenarioViewMode]: data.isScenarioViewMode === true,
      })}
      style={{ height: data.accumulatedMaxBoardHeight || 'auto' }}
    >
      <p className={styles.title}>{data.name}</p>
      <div
        style={{ width: data.boardWidth }}
      />
    </div>
  );
}

export default memo(CustomBoardNode);
